import _get from 'lodash/get';
import { Constants } from '@pwc/pwc-deals-web-common';
import qs from 'query-string';
import { createSelector } from 'reselect';
import { LINKED_ADJUSTMENTS_BY_DOCUMENT_KEY } from '../utilities/constants';
import { getAdjustmentTypesByCode } from './adjustmentSelectors';

export const getLinkedAdjustmentsByDocument = (state) =>
  state[LINKED_ADJUSTMENTS_BY_DOCUMENT_KEY];

const documentAsSourceLinkBuilder = (documentCode) => (link) => {
  const {
    sourceDocumentCode,
    sourceAdjustmentType,
    sourceAdjustmentNumber,
    sourceDisplayName,
    targetDocumentCode,
    targetAdjustmentType,
    targetAdjustmentNumber,
    targetDisplayName,
  } = link;

  return {
    source:
      documentCode === sourceDocumentCode
        ? {
            documentCode: sourceDocumentCode,
            adjustmentType: sourceAdjustmentType,
            adjustmentNumber: sourceAdjustmentNumber,
            adjustmentDisplayName: sourceDisplayName,
          }
        : {
            documentCode: targetDocumentCode,
            adjustmentType: targetAdjustmentType,
            adjustmentNumber: targetAdjustmentNumber,
            adjustmentDisplayName: targetDisplayName,
          },

    target:
      documentCode === sourceDocumentCode
        ? {
            documentCode: targetDocumentCode,
            adjustmentType: targetAdjustmentType,
            adjustmentNumber: targetAdjustmentNumber,
            adjustmentDisplayName: targetDisplayName,
          }
        : {
            documentCode: sourceDocumentCode,
            adjustmentType: sourceAdjustmentType,
            adjustmentNumber: sourceAdjustmentNumber,
            adjustmentDisplayName: sourceDisplayName,
          },
  };
};

const linkValidator = (link, allAdjustments) => {
  const {
    documentCode: sourceDocumentCode,
    adjustmentType: sourceAdjustmentType,
    adjustmentDisplayName: sourceAdjustmentDisplayName,
  } = link.source;

  const {
    documentCode: targetDocumentCode,
    adjustmentType: targetAdjustmentType,
    adjustmentDisplayName: targetAdjustmentDisplayName,
  } = link.target;

  const foundSourceAdjustment = _get(
    allAdjustments,
    [sourceDocumentCode, sourceAdjustmentType, sourceAdjustmentDisplayName],
    null
  );

  const foundTargetAdjustment = _get(
    allAdjustments,
    [targetDocumentCode, targetAdjustmentType, targetAdjustmentDisplayName],
    null
  );

  return {
    ...link,
    isSourceBroken: foundSourceAdjustment === null,
    isTargetBroken: foundTargetAdjustment === null,
  };
};

export const createSelectorGetLinkedAdjustmentsAsSourceForDocument = (
  documentCode
) =>
  createSelector(
    getLinkedAdjustmentsByDocument,
    getAdjustmentTypesByCode,
    (linkedAdjustments, allAdjustments) => {
      const documentLinkedAdjustments = _get(
        linkedAdjustments,
        documentCode,
        []
      );

      const sourceLinkBuilder = documentAsSourceLinkBuilder(documentCode);

      const linksForSourceDocument = documentLinkedAdjustments
        .map(sourceLinkBuilder)
        .map((link) => linkValidator(link, allAdjustments))
        .filter((link) => !link.isSourceBroken)
        .map((link) => ({
          source: link.source,
          target: {
            ...link.target,
            queryString: link.isTargetBroken
              ? null
              : qs.stringify({
                  adjustmentType: link.target.adjustmentType,
                  adjustmentName: link.target.adjustmentDisplayName,
                }),
          },
          isBroken: link.isTargetBroken,
        }));

      return linksForSourceDocument;
    }
  );

export const getLinkedAdjustmentsAsSourceForQofE =
  createSelectorGetLinkedAdjustmentsAsSourceForDocument(
    Constants.QUALITY_OF_EARNINGS
  );

export const getLinkedAdjustmentsAsSourceForNwc =
  createSelectorGetLinkedAdjustmentsAsSourceForDocument(
    Constants.NET_WORKING_CAPITAL
  );

export const getLinkedAdjustmentsAsSourceForDdl =
  createSelectorGetLinkedAdjustmentsAsSourceForDocument(
    Constants.DEBT_AND_DEBT_LIKE
  );
